_generateCookieString